<template>
  <footer>
    <div class="container clearBoth">
      <div class="logo"><img @click="goHome" src="@/assets/logo.png"></div>
      <ul class="footer_content flex">
        <li class="footer_content_item" v-for=" item in navList" :key="item.id">
          <h6>{{ item.title }}</h6>
          <a class="footer_content_text" v-for="nav in item.itemList" :key="nav.id" @click="routerLink(nav)">{{ nav.name }}</a>
        </li>

        <li class="footer_content_item" v-for=" item in contact" :key="item.id">
          <h6>{{ item.title }}</h6>
          <p class="footer_content_text" v-for="nav in item.itemList" :key="nav.id" @click="routerLink(nav)">{{ nav.name }}</p>
        </li>
      </ul>
      <!--<div class="qrcode"><img src="@/assets/qrcode.png" alt=""></div>-->
    </div>
    <div class="copyright">Copyright © 2022 北京政通征信有限公司 版权所有 | <a href="http://beian.miit.gov.cn/" style="color: #D9D9D9">京ICP备2021007605号-1</a></div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data(){
    return{
      navList:[
        {
          title:'便捷导航',
          itemList:[
            {
              id:0,
              name:'三维信用诊断',
              path:'/module',
              meta:'?id=7&text=三维信用诊断系统'
            },
            {
              id:1,
              name:'文案撰写与咨询培训',
              path:'/zhengxinfu/0'
            },
            {
              id:2,
              name:'模块产品',
              path:'/module',
              meta:'?id=7&text=三维信用诊断系统'
            },
            {
              id:3,
              name:'年度重点课题项目',
              path:'/projects/1'
            }
          ]
        },
        {
          title:'推荐产品',
          itemList:[
            {
              id:0,
              name:'信用规划编制',
              path:'/zhengxinfu/1'
            },
            {
              id:1,
              name:'权威专家咨询与辅导',
              path:'/zhengxinfu/3'
            },
            {
              id:2,
              name:'信用预警机',
              path:'/module',
              meta:'?id=11&text=信用预警机'
            },
            {
              id:3,
              name:'企业信管家',
              path:'/module',
              meta:'?id=8&text=企业信管家'
            },
            {
              id:4,
              name:'信用监管套餐',
              path:'/module',
              meta:'?id=9&text=信用监管套餐'
            },

          ]
        }
      ],
      contact:[
        {
          title:'联系我们',
          itemList:[
            {
              id:0,
              name:'电子邮箱：wujianvc@163.com'
            },
            {
              id:1,
              name:'联系电话：010-8076 5311'
            },
            {
              id:2,
              name:'工作时间：9:30~17:30（法定工作日）'
            },
            {
              id:3,
              name:'联系地址：北京市昌平区北清路1号院珠江摩尔国际大厦'
            }
          ]
        }
      ]
    }
  },
  methods:{
    goHome(){
      if(this.$route.name=='home'){
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
      }else{
        this.$router.push('/');
      }
    },
    routerLink(nav){
      if(this.$route.path==nav.path){
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
      }else{
        if(nav.meta){
          this.$router.push(nav.path+nav.meta);
        }else{
          this.$router.push(nav.path);
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
  footer{
    background: #005293;
    color: #fff;
    .copyright{
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #3E3E3E;
      font-size: 12px;
      color: #D9D9D9;
    }
    .logo{
      margin-right:30px;
      float: left;
      line-height: 260px;
      img{
        width: 110px;
      }
    }
    .qrcode{
      float: right;
      width: 102px;
      text-align: center;
      margin-top: 90px;
      img{
        width: 102px;
      }
    }
    .footer_content{
      padding: 55px 0;
      float: left;
      .footer_content_item{
        margin-left: 55px;
        h6{
          position: relative;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 20px;
          &:after{
            content: "";
            display: block;
            width: 100px;
            height: 1px;
            background: #003667;
            position: absolute;
            left:0;
            bottom: -10px;
          }
        }
        .footer_content_text{
          display: block;
          line-height: 2;
          font-size: 14px;
          color: #fff;
        }
      }
    }
  }
</style>
